<div class="content grid-1-auto md3-surface">
	<div class="content md3-card-on-surface">
		<app-exc-pdfviewer-v3 [docPath]="viewerurl"
		                      [docID]="frmTData.frmTID"
		                      [docName]="frmTData.frmTName"

		                      [showFileUpload]="excSecurity.isFeatured('FORMTMGMT')"
		                      [showFormulaToolbar]="excSecurity.isFeatured('FORMTMGMT')"
		                      [canShowFormulaToolbar]="excSecurity.isFeatured('FORMTMGMT')"
		                      [showAnnotationToolbar]="false"
		                      [defaultFormularMode]="excSecurity.isFeatured('FORMTMGMT') ? 'design' : 'fill'"

		                      (fileUploaded)="receiptPDFViewer.fileUploaded($event)"

		                      (viewerDocumentLoaded)="receiptPDFViewer.onDocumentLoaded()"
		                      (viewerPageClicked)="receiptPDFViewer.pageClicked()"
		                      (ready)="receiptPDFViewer.onViewerReady()">
		</app-exc-pdfviewer-v3>
	</div>

	<div class="content md3-card-on-surface">
		<div class="app-layout-frame-drawer" style="width: 480px" #DivDrawer>
			<div class="content">
				<app-exg-tab-v2 #VCrightTabControl
				         [header]="rightTabs"
				         [hidden]="!loaded">
					<ng-template #pages>
						<!-- 1 - Placeholder -->
						<div class="content">
							<div class="layout-auto-1">
								<exg-search-bar
									[placeholder]="getRessource('placeholderSearchText')"
									(Search)="placeholderSearchText = $event">
								</exg-search-bar>
								<div class="content">
									<exg-data-list #VCPlaceholderList
									               selectKey="id"
									               [displayState]="getPlaceholderItems() && getPlaceholderItems().length > 0 ? 0 : 2"
									               [rowSource]="getPlaceholderItems()">
										<ng-template #rowTemplate let-placeholder>
											<div class="list-row list-row-auto-1-auto app-cursor-pointer"
											     (click)="copyToClipboard(placeholder.id)">
												<div></div>
												<div class="">
													<div class="list-primary-text">{{placeholder.text}}</div>
													<div class="list-secondary-text">{{placeholder.id}}</div>
												</div>
												<div class="list-metadata">
												</div>
											</div>
										</ng-template>
									</exg-data-list>
								</div>
							</div>
						</div>
					</ng-template>
				</app-exg-tab-v2>
				<!-- loading Drawer -->
				<div *ngIf="!loaded" class="splash loading">
					<div class="spinner">
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			</div>
			<!-- Right Quickactions -->
			<div class="app-drawer">
				<i class="disabled search-filter-action"></i>
				<i class="search-filter-seperator"></i>
				<i class="fal fa-save search-filter-action"
				   (click)="formularTemplate(false)"
				   [class.disabled]="!VCPdfViewer?.isDirty"
				   [tooltip]="getGlobal('Save')"
				   flow="left">
				</i>
				<i class="fal fa-pencil search-filter-action"
				   (click)="openModalOeFormularTemplateComponent(frmTData)"
				   [tooltip]="getGlobal('Edit')"
				   flow="left">
				</i>
			</div>
		</div>
	</div>
</div>
